import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  TypesOfBenefitsIcon,
  OrganizationalBenefitsIcon,
  ReasonForPointAwardingIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const BenefitsSettingsBox = () => {

  const data = [
    {
      name: getLocalizedString("typesOfBenefits"),
      icon: <TypesOfBenefitsIcon />,
      path: paths.typesOfBenefits,
    },
    {
      name: getLocalizedString("organizationalBenefits"),
      icon: <OrganizationalBenefitsIcon />,
      path: paths.organizationalBenefits,
    },
    {
      name: getLocalizedString("reasonsForPointDelivery"),
      icon: <ReasonForPointAwardingIcon />,
      path: paths.reasonForPointAwarding,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("benefitsSettingsBox")}
      data={data}
    />
  );
}

export default BenefitsSettingsBox;
